/** Get Popup Container **/
export const getPopupContainer: getPopupContainerType = (trigger) => trigger;

type getPopupContainerType = (trigger: HTMLElement) => HTMLElement;
